import React, { createContext, useContext, useState, useEffect } from 'react';

interface SidebarContextType {
  collapsed: boolean;
  isCollapsed: boolean;
  setCollapsed: (v: boolean) => void;
  toggleCollapsed: () => void;
  sidebarWidth: string;
}

const SidebarContext = createContext<SidebarContextType>({
  collapsed: false,
  isCollapsed: false,
  setCollapsed: () => {},
  toggleCollapsed: () => {},
  sidebarWidth: '240px',
});

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      const saved = localStorage.getItem('nexo_sidebar_collapsed');
      if (saved !== null) return JSON.parse(saved) === true;
    } catch (e) {}
    return false;
  });

  const toggleCollapsed = () => {
    setCollapsed(prev => {
      const next = !prev;
      try {
        localStorage.setItem('nexo_sidebar_collapsed', JSON.stringify(next));
      } catch (e) {}
      return next;
    });
  };

  const handleSetCollapsed = (val: boolean) => {
    setCollapsed(val);
    try {
      localStorage.setItem('nexo_sidebar_collapsed', JSON.stringify(val));
    } catch (e) {}
  };

  const sidebarWidth = collapsed ? '70px' : '240px';

  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-width', sidebarWidth);
  }, [sidebarWidth]);

  return (
    <SidebarContext.Provider value={{ collapsed, isCollapsed: collapsed, setCollapsed: handleSetCollapsed, toggleCollapsed, sidebarWidth }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
